import React from "react";
import { Box, Grid } from "@mui/material";
import SampleItem from "./SampleItem";
import { useSamplesList, useSystemId } from "../../../../hooks/useReduxSelectors";



function SampleView() {

  const systemId = useSystemId();
  const samples = useSamplesList();

  return (
    <Box sx={{ width: '100%', px: 1 }}>
      <Grid container spacing={1}>
        {samples && samples.length > 0 &&
          samples.map((sample) => (
            <Grid
              key={systemId + "_" + sample.hwId}
            >
              <SampleItem
                key={systemId + "_" + sample.hwId}
                sample={sample}
              />
            </Grid>
          ))
        }
      </Grid>
    </Box>
  );
}

export default SampleView;